import React from "react";
import html2canvas from "html2canvas";
import * as jsPDF from "jspdf";
window.html2canvas = html2canvas;

const AdmissionLetterGenericPdfDownloader = ({ 
  rootElementId, 
  downloadFileName, 
  blobImages = [] 
}) => {
  const downloadPdfDocument = async () => {
    const input = document.getElementById(rootElementId);
    
    // Handle canvas conversion of root element
    const canvas = await html2canvas(input, { useCORS: true });
    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    // Create new PDF
    const pdf = new jsPDF("l", "mm", "a4");
    pdf.addImage(imgData, "JPEG", 10, 10, 268, 200);

    // Add blob images to PDF if provided
    for (let i = 0; i < blobImages.length; i++) {
      const blobUrl = URL.createObjectURL(blobImages[i]);
      pdf.addPage();
      pdf.addImage(blobUrl, "JPEG", 10, 10, 268, 200);
      URL.revokeObjectURL(blobUrl);
    }

    pdf.save(`${downloadFileName}.pdf`);
  };

  return (
    <button
      className="btn btn-default align-self-center d-none d-md-flex"
      style={{
        color: "#1782F4",
        borderRadius: "5px",
        background: "#fff",
      }}
      onClick={downloadPdfDocument}
    >
      <strong>Download PDF</strong>
    </button>
  );
};

export default AdmissionLetterGenericPdfDownloader;